import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import AddRowForm from "./AddRowForm";
import SuggestedSolutionForm from "./SuggestedSolutionForm";
import History from "./History";

function Modal(props) {
  props = props.main;
  const navigate = useNavigate();

  const { modalType } = props.modalData;

  const adminAccess = props.userType === "admin" ? true : false;

  const modalElement = useRef();

  const [dragging, setDragging] = useState();
  const [modalProperties, setModalProperties] = useState({
    style: {
      left: "50%",
      top: "50%",
    },
    mouse: {
      x: 0,
      y: 0,
    },
    offset: {
      x: 0,
      y: 0,
    },
    state: {
      fullScreen: false,
    },
  });

  useEffect(() => {
    props.setBackgroundBlur((prev) => !prev);
    return () => {
      props.setBackgroundBlur((prev) => !prev);
    };
  }, []);

  function drag(e) {
    e.persist();
    //e.preventDefault();
    if (!dragging) return;
    const elementLeft = modalElement.current.offsetLeft,
      elementTop = modalElement.current.offsetTop,
      mouseLeft = e.clientX,
      mouseTop = e.clientY;
    setModalProperties((prev) => ({
      ...prev,
      style: {
        ...prev.style,
        left: prev.style.left + (mouseLeft - elementLeft) - prev.offset.x,
        top: prev.style.top + (mouseTop - elementTop) - prev.offset.y,
      },
      mouse: {
        x: mouseLeft,
        y: mouseTop,
      },
    }));
  }

  function dragStart(e) {
    e.persist();

    setModalProperties((prev) => ({
      ...prev,
      style: {
        ...prev.style,
        position: "absolute",
        opacity: 0.87,
        boxShadow: "4px 4px 15px rgba(0,0,0,.1)",
      },
      offset: {
        x: e.clientX - modalElement.current.offsetLeft,
        y: e.clientY - modalElement.current.offsetTop,
      },
    }));
    setDragging(true);
  }

  function dragEnd() {
    setModalProperties((prev) => ({
      ...prev,
      style: {
        ...prev.style,
        opacity: 1,
        boxShadow: "0 0 transparent",
      },
    }));
    setDragging(false);
  }

  useEffect(() => {
    setModalProperties((prev) => ({
      ...prev,
      style: {
        left: modalElement.current.offsetLeft,
        top: modalElement.current.offsetTop,
      },
    }));
  }, []);

  // The content to display
  const modalContent = () => {
    switch (modalType) {
      case "new":
      case "edit":
        return (
          <AddRowForm
            adminAccess={adminAccess}
            data={props.modalData}
            setData={props.setModalData}
            modalElement={modalElement}
            setUpdate={props.setUpdate}
          />
        );
      case "suggestSolution":
        return <SuggestedSolutionForm itemData={props.modalData} />;
      case "history":
        return <History itemData={props.modalData} tabItems={props.modalData.tabItems}></History>;
    }
  };

  let heading = "";
  switch (modalType) {
    case "new":
      heading = "Nowa pozycja";
      break;
    case "edit":
      heading = "Edytuj";
      break;
    case "suggestSolution":
      heading = "Proponowane rozwiązanie sytuacji";
      break;
    case "history":
      heading = "Historia zmian";
      break;
  }

  if (!modalType) navigate("../");

  return (
    <div className="modalWrapper" onMouseMove={drag} onMouseUp={dragEnd}>
      <div
        ref={modalElement}
        className={
          "modal" + (modalProperties.state.fullScreen ? " fullScreen" : "")
        }
        style={modalProperties.style}
      >
        <div className="modalHeading">
          <h2 onMouseDown={dragStart}>{heading}</h2>
          <div
            className="modalWindowOption toggleMaximize"
            onClick={() => {
              setModalProperties((prev) => ({
                ...prev,
                state: {
                  ...prev.state,
                  fullScreen: !prev.state.fullScreen,
                },
              }));
            }}
          >
            {modalProperties.state.fullScreen ? "🡷" : "⤢"}
          </div>
          <div
            className="modalWindowOption closeModal"
            onClick={() => {
              navigate("../");
            }}
          >
            ✖
          </div>
        </div>
        {modalContent()}
      </div>
    </div>
  );
}

export default Modal;
